import React, { useEffect, useRef } from "react";
import { useSpring, animated } from "react-spring";
import coconut from "../data/images/coconut-tree.svg";
import { Modal } from "@mui/material";

// Here you can modify the number of coconuts that you want to display
const numberOfCoconuts = 8;
// This is the radius of the circular path along which the coconuts move
const radius = 50;
// This is the size of each coconut. You can increase or decrease this value to resize the coconuts
const coconutSize = 20;
// Here we are creating an array of coconuts, each having an angle which determines its initial position
const coconuts = Array.from({ length: numberOfCoconuts }, (_, i) => ({
  angle: (2 * Math.PI * i) / numberOfCoconuts,
}));

// This is a component for each coconut
const Coconut = ({ angle }) => {
  const ref = useRef(null);

  useEffect(() => {
    // This is to ensure that the rotation happens around the center of the parent div and not the top left corner
    if (ref.current) {
      ref.current.style.transformOrigin = `${radius}px ${radius}px`;
    }
  }, []);

  return (
    <img
      ref={ref}
      src={coconut}
      alt="coconut"
      style={{
        position: "absolute",
        width: coconutSize,
        height: coconutSize,
        // These position each coconut correctly around the circle at start
        left: radius - coconutSize / 2 + radius * Math.cos(angle),
        top: radius - coconutSize / 2 + radius * Math.sin(angle),
      }}
    />
  );
};

// This is the main component that contains the rotating coconuts
const LoadingModal = ({ open }) => {
  // This is the animation that rotates the parent div containing the coconuts
  const props = useSpring({
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
    loop: true, // this keeps the rotation going in the same direction
    config: { duration: 2500 }, // You can change the duration to speed up or slow down the rotation
    reset: open,
  });

  return (
    <Modal
      open={open}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "brown", // To darken the modal, you can change the alpha value (0.8 here)
        outline: "none", // To remove any possible outline
      }}
    >
      <animated.div
        style={{
          ...props,
          position: "relative",
          width: 2 * radius,
          height: 2 * radius,
          outline: "none", // To remove any possible outline
        }}
      >
        {/* Here we render each coconut */}
        {coconuts.map((coconutObj, i) => (
          <Coconut key={i} angle={coconutObj.angle} />
        ))}
      </animated.div>
    </Modal>
  );
};

export default LoadingModal;
